import React, { useState, useRef, useEffect } from "react"
import { useSelector } from "react-redux"
import { redirectToOmnicuris } from "../utilities"
import { DefaultProfileIcon } from "../utilities/resources"
import Experts2 from "./Experts2"
import Img from "./Img"
import ModalBox from "./ModalBox"

function Experts(props) {
  const { domainDetails } = useSelector((state) => state.listings)
  const { data, containerRef, fixedLimit, gap, expertsAvatarClass, plusMoreClass, width, height } = props
  const [limit, setLimit] = useState(0)
  const [visibleModal, setVisibleModal] = useState(false)
  const gridRef = useRef(null)
  const expertRef = useRef(null)
  const eleGap = gap ? gap : 10

  useEffect(() => {
    const clientWidth = containerRef.current && containerRef.current.clientWidth
    const expertWidth = expertRef.current && expertRef.current.offsetWidth + eleGap
    const totalWidth = data.length * expertWidth + expertWidth
    if (fixedLimit) {
      setLimit(fixedLimit)
    } else if (totalWidth > clientWidth) {
      setLimit(((clientWidth - expertWidth) / expertWidth) | 0)
    }
  }, [gridRef && expertRef, fixedLimit])

  const elements = (items, index) => {
    return (
      <div ref={expertRef} key={index} onClick={(ev) => navigate(ev, items.id)} className={`expertsAvatar ${expertsAvatarClass ? expertsAvatarClass : ""}`} style={{ height: height ? height : "", width: width ? width : "" }}>
        <div className="expertsDp">
          <Img src={items.image ? items.image : items.profilePic} defaultSrc={DefaultProfileIcon} alt="" />
        </div>
        <div className="expertsTooltip">
          <p>{items.name ? items.name : items.expertName}</p>
          <p>{items.qualification ? items.qualification : items.qualification}</p>
        </div>
      </div>
    )
  }

  const navigate = (ev, id) => {
    ev.stopPropagation()
    // if (domainDetails && domainDetails.orgType === 'certifier') {
    //   redirectToOmnicuris(`/expert/${id}`, window.self != window.top);
    // } else {
    return false
    // }
  }

  const handleVisibleModal = (ev) => {
    ev.stopPropagation()
    setVisibleModal(true)
  }

  return (
    <div className="expertsWrapper">
      <div ref={gridRef} className="expertsGrid">
        {data.length > 0 &&
          (limit > 0
            ? data.slice(0, limit).map((items, index) => {
                return elements(items, index)
              })
            : data.map((items, index) => {
                return elements(items, index)
              }))}
      </div>
      {limit > 0 && limit !== data.length && (
        <div onClick={handleVisibleModal} className={`plusMore ${plusMoreClass ? plusMoreClass : ""}`} style={{ height: height ? height : "", width: width ? width : "", minWidth: width ? width : "" }}>
          +{data.length - limit}
        </div>
      )}

      <ModalBox title="Experts" visible={visibleModal} setVisible={setVisibleModal} width="750px">
        <div className="expertsTilesGrid">
          {data.map((items, index) => {
            return <Experts2 key={index} id={items.id} name={items.name ? items.name : items.expertName} media={items.profilePic} qualification={items.qualification} location={items.location} index={index} />
          })}
        </div>
      </ModalBox>
    </div>
  )
}

export default Experts
